import { monthLabelOf } from "@couples/shared";
import SheetShell from "./SheetShell";

interface Props {
  /** 月キー(`2026-08`)ごとの件数。新しい順に並べ直して出す */
  counts: Map<string, number>;
  onPick: (monthKey: string) => void;
  onClose: () => void;
}

/** 月を選んで飛ぶ。枚数が増えると、目的の月まで延々スクロールすることになる */
export default function MonthSheet({ counts, onPick, onClose }: Props) {
  const months = [...counts.entries()].sort(([a], [b]) => b.localeCompare(a));

  return (
    <SheetShell title="月を選ぶ" onClose={onClose}>
      <div className="flex flex-col overflow-y-auto pb-3">
        {months.map(([month, count]) => (
          <button
            key={month}
            type="button"
            onClick={() => {
              onPick(month);
            }}
            className="flex items-center justify-between border-b border-[var(--color-line)] px-4 py-3 text-sm"
          >
            <span>{monthLabelOf(month)}</span>
            <span className="text-xs text-[var(--color-sub)]">{count}件</span>
          </button>
        ))}

        {months.length === 0 && (
          <p className="px-4 py-6 text-center text-sm text-[var(--color-sub)]">
            まだ写真がありません。
          </p>
        )}
      </div>
    </SheetShell>
  );
}
